<template>
    <v-layout align-center justify-center class="attpicviewer_bg">
        <v-toolbar fixed flat class="transparent" style="color:white;">
         
          <v-spacer></v-spacer>
          <v-toolbar-items>       
              <v-btn dark flat @click="closeDialog">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm8 md4>      
            <div class="img-viewer">  
                <v-img ref="avatar" @click="closeDialog"></v-img>
            </div>    
        </v-flex>
    </v-layout>
</template>
<script>

import commonfn from '@/common/functions'
export default {
    data() {
        return {}
    },   
    methods: {
        viewAttenancePic(data, action) {
            this.$refs.avatar.src = commonfn.getAttendancActualPicUrl(data.userId, this.$moment(data.transDate).format('YYYY-MM-DD'), action)
        },
        closeDialog() {
            this.$emit('update:dialogPicViewer', false)
        }
    },
    created() {}
}
</script>
<style scoped>
.attpicviewer_bg {
    /* The image used */
    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: black;
}
.img-viewer {
    max-width:100%;
    width:100%;
    text-align:center;
    border-radius:4px;
}
</style>